import React from 'react';
import i18n from 'i18next';
import classnames from 'classnames';

import { NestedListContainer } from '@/exceed';

import FilterOption from './filterOption';

import styles from '../styles/filterOptions.module.scss';

const FilterOptions = ({
  isLoading,
  level = 0,
  options,
  param,
  onSelectionUpdate,
  selection,
  selectionAncestors,
  shouldAllItemsBeSelectable
}) => (
  options.map(({ options: nestedOptions, text, value }) => {
    const hasNestedOptions = Boolean(nestedOptions.length);
    const isSelected = selection.includes(value);

    return (
      <li className={classnames(isLoading && styles.isLoading)} key={value}>
        <NestedListContainer
          bodyAriaLabel={text}
          bodyClassName={styles.body}
          hasToggle={hasNestedOptions}
          header={(
            <FilterOption
              isSelectable={!hasNestedOptions || shouldAllItemsBeSelectable}
              isSelected={isSelected}
              name={text}
              onChange={(checked) => (
                onSelectionUpdate({ isSelected: checked, key: param, value })
              )}
              value={value}
            />
          )}
          headerClassName={styles.header}
          headerPrepend={<div style={{ width: `${20 * level}px` }} />}
          id={value}
          initialExpandedIds={selectionAncestors}
          toggleButtonSize="xsmall"
        >
          {hasNestedOptions && (
            <ul className={styles.bodyContainer}>
              <FilterOptions
                level={level + 1}
                onSelectionUpdate={onSelectionUpdate}
                options={nestedOptions}
                param={param}
                selection={selection}
                selectionAncestors={selectionAncestors}
                shouldAllItemsBeSelectable={shouldAllItemsBeSelectable}
              />
            </ul>
          )}
        </NestedListContainer>
      </li>
    );
  })
);

export default React.memo(FilterOptions);
